import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { RouteComponentProps, useParams } from "react-router-dom";
import { getPodiumBackgroundImageUrl } from "../app/helpers/urlHelper";
import { RootStoreContext } from "../app/stores/rootStore";
import Loader from "../components/common/Loader";
import PodiumSpeakersContainer from "../components/podium/PodiumSpeakersContainer";
import PodiumTitleComponent from "../components/podium/PodiumTitleComponent";
import { toast } from "react-toastify";

interface IParams {
  meetingId: string;
  accept:string;
}

const PodiumSpeakersListPage: React.FC<RouteComponentProps<IParams>> = ({
  match,
  history,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { loadPodiumData, currentPodium } = rootStore.podiumStore;
  const { currentTenant } = rootStore.tenantStore;
  const [redirectToDashboard, setRedirectToDashboard] = useState(false);
  const [preview, setPreview] = useState((match.params.accept !=="")? true : false);

  
  
  useEffect(() => {

    const meetingId = parseInt(match.params.meetingId);
    if (match.params.accept ==="" || match.params.accept === undefined){
      setPreview(false)
    }
    loadPodiumData(meetingId, preview)
      .then((dto) => {
          if (!dto) setRedirectToDashboard(true);
      })
      .catch(() => setRedirectToDashboard(true));
  }, [match.params.meetingId,match.params.accept, preview, loadPodiumData]);

  useEffect(() => {
    if (redirectToDashboard) {
      let errorUrl = currentTenant ? `${currentTenant.path}` : "/";
      history.push(errorUrl);
    }
  }, [redirectToDashboard, currentTenant, history]);

  if (!currentPodium) return <Loader />;

  return (
    <>
      <div
        className="podium-full-bg"
        style={{ backgroundColor: currentPodium.settings.backgroundColor }}
      >
        {currentPodium.settings.hasBackgroundImage && (
          <div
          className="podium-full-bg podium-full-bg-img"
            style={{
              backgroundImage: `url("${getPodiumBackgroundImageUrl(
                match.params.meetingId
              )}`,
            }}
          ></div>
        )}
        <div className="podium-full-bg">
          <div className="podium-container d-flex flex-column">
            <div className="my-2">
              <PodiumTitleComponent
                text={currentPodium.settings.title}
                font={currentPodium.settings.titleFont}
                fontColor={currentPodium.settings.titleFontColor}
                fontSize={
                  currentPodium.settings.titleFontSize > 0
                    ? currentPodium.settings.titleFontSize
                    : undefined
                }
              />
            </div>

            <PodiumSpeakersContainer
              preview={preview}
              speakers={currentPodium.speakers}
              settings={currentPodium.settings}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default observer(PodiumSpeakersListPage);
